import { Component, OnInit } from '@angular/core';
import { faCheck, faPlus, faMinus } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-privacy',
    templateUrl: './privacy.component.html',
    styleUrls: ['./privacy.component.less'],
    standalone: false
})
export class PrivacyComponent implements OnInit {

  faCheck = faCheck;
  faPlus = faPlus;
  faMinus = faMinus;

  constructor() {}

  btnOne;
  btnTwo;
  btnThree;
  btnFour;
  btnFive;
  btnSix;
  btnSeven;
  btnEight;
  btnNine;
  btnTen;
  btnEleven;

  ngOnInit() {
    this.btnOne = <HTMLElement>document.getElementById('btn1');
    this.btnTwo = <HTMLElement>document.getElementById('btn2');
    this.btnThree = <HTMLElement>document.getElementById('btn3');
    this.btnFour = <HTMLElement>document.getElementById('btn4');
    this.btnFive = <HTMLElement>document.getElementById('btn5');
    this.btnSix = <HTMLElement>document.getElementById('btn6');
    this.btnSeven = <HTMLElement>document.getElementById('btn7');
    this.btnEight = <HTMLElement>document.getElementById('btn8');
    this.btnNine = <HTMLElement>document.getElementById('btn9');
    this.btnTen = <HTMLElement>document.getElementById('btn10');
    this.btnEleven = <HTMLElement>(document.getElementById('btn11'));
  }
}
